import {MeasureChart} from "@components/measure-chart";
import {
  Card,
  CardHeader,
  Stack,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import {MeasureMap} from ".";
import {Sensor} from "@core/model/Sensor";
import {renderAssetTypeIcon} from "@util";

const MonitoringVertical = ({
  selected,
  measureMap,
  limit,
  sx,
}: {
  selected: Sensor[];
  measureMap: MeasureMap;
  limit: number;
  sx?: SxProps<Theme>;
}) => {
  const fullSize = selected.length === 1;
  return (
    <Stack direction={"column"} gap={2} overflow={"auto"} flex={1} sx={{...sx}}>
      {selected.slice(0, limit).map(s => (
        <Card
          key={`vertical-sensor-chart-${s.id}`}
          className="chart-container"
          sx={{
            flex: 1,
            minHeight: fullSize ? "100%" : 400,
            maxHeight: fullSize ? "100%" : 400,
            minWidth: "100%",
            maxWidth: "100%",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            "& .series-selector-container": {
              position: "absolute",
              top: 12,
              right: 8,
              zIndex: 1,
            },
          }}>
          <CardHeader
            title={
              <Stack direction={"row"} alignItems={"center"} gap={1}>
                <Typography>{s.name}</Typography>{" "}
                {renderAssetTypeIcon(s.type, "small")}
              </Stack>
            }
          />
          <MeasureChart sensor={s} measures={measureMap[s.name] ?? []} live />
        </Card>
      ))}
    </Stack>
  );
};

export {MonitoringVertical};
